<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Loader } from '@client/components/loader';
  import { Spinner } from '@client/components/spinner';

  import { RoutingService } from '@client/services/routing';
  import { TagBlocksService } from '@client/services/tag-blocks';

  import { deepCopy } from '@common/utils/objects';

  import { SignatureRouteForm } from '../shared';

  export let route = {};
  export let show = false;
  export let senderGroups = [];
  export let tagOptions = [];
  export let groupOptions = [];
  export let signaturesOptions = [];
  export let onAdd = () => {};
  export let updatePriorityPositions = () => {};
  export let priority = [];

  let originalRoute = deepCopy(route);
  let isUpdating = false;
  let filterText = '';
  let updatingSignature = false;

  let expanded = false;

  const addItem = (e) => {
    const currentTags = route?.tags || [];

    if (e.key === 'Enter') {
      if (route.selectedTags.map(({ value }) => value).includes(filterText)) {
        filterText = '';
        return;
      }

      if (!currentTags.includes(filterText) && filterText.length) {
        route.selectedTags = [{ label: filterText, value: filterText }, ...route.selectedTags];
        filterText = '';
      }
    } else {
      if (!filterText.length && e.detail.value) {
        const selected = e.detail.value;

        if (!currentTags.includes(selected) && selected.length) {
          route.selectedTags = [selected, ...route.selectedTags];
        }
      }
    }
  };

  const onSave = async () => {
    isUpdating = true;

    const tags = (route.selectedTags || []).map(({ value }) => ({ text: value }));
    const selectedGroups = (route.selectedGroups || []).map(({ value }) => value);
    const sendergroups = senderGroups.filter(({ groupname }) => selectedGroups.includes(groupname));
    const { blockname, status, tagblock = {}, _id } = route;
    const isNewRoute = _id === undefined;

    const payload = {
      blockname,
      hide: route.hide,
      priority: route.priority,
      header: route.header,
      sendergroups,
      status: route.status,
      tagblock,
      tags
    };

    if (!isNewRoute) {
      payload._id = _id;
      payload.priority = payload.priority - 1;
    }

    const response = await RoutingService.updateRoute(payload);
    const sgroups = senderGroups.filter(
      ({ groupname }) => sendergroups.filter((group) => groupname === group.groupname).length
    );

    route = {
      ...response,
      ...route,
      selectedTags: route.selectedTags || [],
      selectedGroups: route.selectedGroups || [],
      sendergroups: sgroups,
      header: route.header,
      status: route.status,
      editing: false
    };

    if (isNewRoute) {
      priority.push(route);
      priority = updatePriorityPositions(priority, priority.length - 1, 0);
      await onAdd();
    }

    priority = priority.map((item) => (!item._id || item?._id === route._id ? route : item));

    route = null;
    show = false;
    isUpdating = false;
  };

  const onCancel = () => {
    route = null;
    show = false;
    expanded = false;
  };

  const onSignatureChange = async (e) => {
    updatingSignature = true;

    const blockname = e.detail.value;
    const response = await TagBlocksService.getById(blockname);

    route = {
      ...route,
      blockname,
      tagblock: response
    };

    updatingSignature = false;
  };

  const onUpdateHandler = () => onUpdate(route);

  if (route?.selectedTags?.length || route?.header || route?.hide) {
    expanded = true;
  }
</script>

<Modal bind:isOpen={show} size="md" fullscreen="md" aria-labelledby="modal-title" role="dialog">
  <ModalBody class="edit-group-route">
    <Spinner show={isUpdating} backdrop />
    <Loader show={updatingSignature} backdrop />
    <div class="edit-group-route-container">
      <button class="close" on:click={onCancel} aria-label="Close modal" tabindex="0">
        <Icon name="x" aria-hidden="true" />
      </button>

      <div class="heading">
        <h1 id="modal-title">
          {#if route._id}
            {$format('label.EDIT_ROUTE')} #{route.priority}
          {:else}
            {$format('label.CREATE_ROUTE')}
          {/if}
        </h1>
      </div>

      <div class="form">
        <SignatureRouteForm
          bind:route
          bind:signaturesOptions
          bind:groupOptions
          bind:tagOptions
          bind:filterText
          bind:expanded
          {onSignatureChange}
          {addItem}
        />
      </div>
    </div>
  </ModalBody>
  <ModalFooter class="border-top p-4 mt-2">
    <Button color="link" on:click={onCancel}>
      {$format('label.CANCEL')}
    </Button>
    <Button color="primary" on:click={onSave} disabled={isUpdating}>
      {#if route._id}
        {$format('label.UPDATE')}
      {:else}
        {$format('label.SAVE')}
      {/if}
    </Button>
  </ModalFooter>
</Modal>

<style lang="scss" src="./edit.scss"></style>
